import React, { useCallback, useMemo } from 'react'
import { Container } from './styles'
import { InputAutocomplete } from '~/components/shared/InputAutocomplete'
import { IFilterTag, IHealthProcedures } from '~/interfaces'
import { theme } from '~/styles'

interface Props {
  options: IHealthProcedures[]
  handleSearch: (value: IFilterTag) => void
}

export const SearchHealthProcedure: React.FC<Props> = ({ options, handleSearch }) => {
  const uniqueOptions = useMemo(() => {
    if (!options?.length) return []

    const descriptions = options.map(option => option.description)
    const uniqueDescriptions = [...new Set(descriptions)]

    return uniqueDescriptions
  }, [options])

  const filterByDescription = useCallback(
    (value: string) => {
      handleSearch({
        id: value,
        text: value,
        color: theme.colors.color378ff7,
        type: 'searchTerm'
      })
    },
    [handleSearch]
  )

  return (
    <Container>
      <InputAutocomplete handleSearch={filterByDescription} optionsList={uniqueOptions} />
    </Container>
  )
}
